import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

const DATE_GROUPS = ["d1", "d2", "d3"];
const PAYMENT_ROWS = ["p1", "p2", "p3"];

const FinanceStatementPageSkeleton = () => (
	<Box sx={{ width: "100%", pt: 2 }}>
		<Stack spacing={3} sx={{ maxHeight: "75vh" }}>
			{DATE_GROUPS.map((dKey) => (
				<Box key={dKey}>
					<Skeleton variant="text" width={160} height={24} sx={{ mb: 1 }} />
					<Stack spacing={1}>
						{PAYMENT_ROWS.map((pKey) => (
							<Paper key={`${dKey}-${pKey}`} sx={{ p: 1.5 }}>
								<Stack
									direction="row"
									sx={{
										justifyContent: "space-between",
										alignItems: "center",
									}}
								>
									<Stack spacing={0.5}>
										<Skeleton variant="text" width={140} height={20} />
										<Skeleton variant="text" width={100} height={16} />
									</Stack>
									<Skeleton variant="text" width={60} height={24} />
								</Stack>
							</Paper>
						))}
					</Stack>
				</Box>
			))}
		</Stack>
		<Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
			<Skeleton
				variant="rectangular"
				width={220}
				height={200}
				sx={{ borderRadius: 1 }}
			/>
		</Box>
	</Box>
);

export default FinanceStatementPageSkeleton;
